module.exports = __webpack_public_path__ + "article-7051a3ee/faehigkeiten-lebenslauf-66f6d767d50c0f2f6fa413e56b10704b.jpg";